import type { HomePageData } from "../services/HomeService";

export type NormalizedGroupStreak = {
  days: number;
  label: string;
  requirement: string;
  all_members_logged_today: boolean | null;
};

/** API may send a number (legacy) or full object (root or per-group). */
export function normalizeGroupStreak(
  raw: unknown
): NormalizedGroupStreak | null {
  if (raw == null) return null;
  if (typeof raw === "number") {
    if (!Number.isFinite(raw)) return null;
    return {
      days: raw,
      label: "",
      requirement: "",
      all_members_logged_today: null,
    };
  }
  if (typeof raw === "object" && raw !== null && "days" in raw) {
    const o = raw as Record<string, unknown>;
    const days =
      typeof o.days === "number" && Number.isFinite(o.days) ? o.days : 0;
    return {
      days,
      label: typeof o.label === "string" ? o.label : "",
      requirement: typeof o.requirement === "string" ? o.requirement : "",
      all_members_logged_today:
        typeof o.all_members_logged_today === "boolean"
          ? o.all_members_logged_today
          : null,
    };
  }
  return null;
}

export function pickGroupStreakFromHome(
  homeData: HomePageData | undefined,
  selectedGroupRaw: unknown
): NormalizedGroupStreak | null {
  return (
    normalizeGroupStreak(selectedGroupRaw) ??
    normalizeGroupStreak(homeData?.group_streak)
  );
}
